import { isInstantBookingLEHotelItem } from 'lib/checkout/checkoutUtils'
import { createSelector } from 'reselect'
import getPaymentScheduleAdjustmentAmount from './getPaymentScheduleAdjustmentAmount'

const getPaymentScheduleAdjustmentRequestInfo = createSelector(
  (state: App.State) => state.checkout.cart.existingOrder,
  (state: App.State) => state.checkout.cart.items,
  (state: App.State) => state.geo.currentCurrency,
  getPaymentScheduleAdjustmentAmount,
  (
    existingOrder,
    cartItems,
    currency,
    adjustmentAmount,
  ): App.Checkout.PaymentScheduleAdjustmentRequestInfo | null => {
    if (!existingOrder) {
      return null
    }

    const hotelItem = cartItems.find(isInstantBookingLEHotelItem)

    if (!hotelItem) {
      return null
    }

    const startDate = hotelItem.checkIn

    if (!startDate) {
      return null
    }

    const adjustedItem = {
      idItems: hotelItem.orderItemId ?? undefined,
      adjustmentAmount,
    }

    if (adjustedItem.idItems === undefined) {
      return null
    }

    return {
      orderId: existingOrder.id,
      bookingInfo: {
        checkinDate: startDate,
        currency,
        idItems: adjustedItem.idItems,
        adjustmentAmount: adjustedItem.adjustmentAmount,
      },
    }
  },
)

export default getPaymentScheduleAdjustmentRequestInfo
